import { PermanentJobsApi } from '../clients';

/**
 * Update candidate status
 *
 * @param {import('../types/UpdateCandidateStatus.parameters').IUpdateCandidateStatusPayload} payload - Request payload
 * @returns {Promise<void>} No content response
 */
export const updateCandidateStatus = async ({ candidateIds, status }) => {
  await PermanentJobsApi.updateCandidateStatus({ candidateIds, status });
};
